import { fromColorPathToColor } from '@weenat/theme'
import { styled } from 'styled-components'

const ANCHOR_SIZE = 8

/**
 * Small circular dot that visually pins the marker to its map coordinate.
 *
 * Border color is injected via a CSS custom property rather than a transient prop
 * to avoid styled-components generating a new CSS class per unique color value.
 * With hundreds of markers on the map each having a distinct color, the class-per-value
 * approach would flood the stylesheet; a CSS var keeps a single rule and updates
 * only the inline custom property.
 */
const MarkerAnchor = styled(Box).attrs(({ $borderColor }) => ({
  style: {
    '--border-color':
      $borderColor != null
        ? fromColorPathToColor($borderColor)
        : fromColorPathToColor('grayscale.black')
  } as React.CSSProperties
}))`
  position: relative;

  background-color: ${(p) => p.theme.colors.grayscale.white};

  border-width: 2px;
  border-style: solid;
  border-color: var(--border-color);

  border-radius: ${(p) => p.theme.radiuses.rounded}px;

  height: ${ANCHOR_SIZE}px;
  width: ${ANCHOR_SIZE}px;
`

export default MarkerAnchor
